export default __webpack_public_path__ + "static/media/cif-lr.76668735.svg";